import { useSelectedSectionsState } from './components/selected_sections'
import { Header } from './header'
import { SectionPane } from './section_pane'
import { Body, Container, Wrapper } from './styles'
import { useDisplaySections } from './use_display_sections'
import { useEventTypeEditorSidebar } from '../hooks'

const BasicPanel = ({ section, title, isEntering, isExiting, ...props }) => (
  <Container
    isEntering={isEntering}
    isExiting={isExiting}
    {...props}
  >
    <Header sectionTitle={title} />
    <Body>
      <SectionPane sectionKey={section} />
    </Body>
  </Container>
)

export const ControlPanel = () => {
  const { isOpen: isETEditorOpen } = useEventTypeEditorSidebar()
  const { selectedSections } = useSelectedSectionsState()
  const [sectionsToDisplay, cleanDisplaySections, removeSection] = useDisplaySections(selectedSections)

  const hideMainPanel = isETEditorOpen && selectedSections.length

  const onAnimationEnd = (currentSectionKey, display) => {
    if (display) {
      cleanDisplaySections()
    } else {
      removeSection(currentSectionKey)
    }
  }

  return (
    <Wrapper isSelectedSection={Boolean(selectedSections.length)}>
      {!hideMainPanel && <BasicPanel />}
      {
        sectionsToDisplay.map(({ display, key, title }) => (
          <BasicPanel
            key={key}
            section={key}
            title={title}
            isEntering={display}
            isExiting={!display}
            onAnimationEnd={() => onAnimationEnd(key, display)}
          />
        ))
      }
    </Wrapper>
  )
}
